import { render } from "./appointmentlist.vue?vue&type=template&id=c2062124"
import script from "./appointmentlist.vue?vue&type=script&lang=js"
export * from "./appointmentlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__